import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Response } from '../interfaces';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnumService {

  constructor(private http: HttpClient) {
  }

  getCitizenShipEnums(): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/citizenship`);
  }

  getPepReasons(): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/pep-reasons`);
  }

  getSourceOfFundsEnum(): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/source-of-funds`);
  }
  getTypeOfBusiness(): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/businesses`);
  }
  getMonthlyDepositEnum(): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/monthly-deposit`);
  }
  getOccuationEnums(): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/occupation`);
  }
  getCountries():Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/countries`);
  }

  isTinApplicabelEnum(countryCode:string): Observable<Response> {
    return this.http.get<Response>(`${ environment.baseurl.api }/enum/tin-applicable/${countryCode}`);
  }
  
}
